import { useIsDesktop, useTypedTranslation } from "@repo/ui";
import { type FC } from "react";
import { Trans } from "react-i18next";
import * as Styled from "./NightRunBanner.styled";

const NIGHT_RUN_LINK =
    "https://www.nn.cz/night-run/?utm_source=prihlaseni.nn.cz&utm_medium=referral&utm_campaign=night-run";
const MAILTO_SUBJECT = "NN%20Night%20Run";

type NightRunBannerProps = {
    showBackgroundImage?: boolean;
};

export const NightRunBanner: FC<NightRunBannerProps> = ({ showBackgroundImage = false }) => {
    const isDesktop = useIsDesktop();
    const { t } = useTypedTranslation();

    const content = (
        <>
            <Styled.BannerHeadingGroup>
                <Styled.BannerHeading>{t("nightRunBanner.headerLine1")}</Styled.BannerHeading>
                <Styled.BannerHeading>{t("nightRunBanner.headerLine2")}</Styled.BannerHeading>
            </Styled.BannerHeadingGroup>
            <Styled.BannerTextStack>
                <Styled.BannerText>
                    <Styled.TextLine>{t("nightRunBanner.textLine1")}</Styled.TextLine>
                    <Styled.TextLine>
                        <Trans i18nKey="nightRunBanner.textLine2" components={{ strong: <Styled.StrongText /> }} />
                    </Styled.TextLine>
                </Styled.BannerText>

                <Styled.BannerText>
                    <Styled.TextLine>{t("nightRunBanner.textLine3")}</Styled.TextLine>
                    <Styled.TextLine>
                        <Trans i18nKey="nightRunBanner.textLine4" components={{ strong: <Styled.StrongText /> }} />
                    </Styled.TextLine>
                </Styled.BannerText>

                <Styled.BannerTextWithPadding>
                    <Styled.TextLine>{t("nightRunBanner.textLine5")}</Styled.TextLine>
                    <Styled.TextLine>
                        <Trans
                            i18nKey="nightRunBanner.textLine6"
                            components={{
                                mail: (
                                    <Styled.MailtoLink
                                        href={`mailto:${t("nightRunBanner.email")}?subject=${MAILTO_SUBJECT}`}
                                    />
                                ),
                            }}
                        />
                    </Styled.TextLine>
                    <Styled.TextLine>{t("nightRunBanner.textLine7")}</Styled.TextLine>
                </Styled.BannerTextWithPadding>
            </Styled.BannerTextStack>

            <Styled.BannerLink href={NIGHT_RUN_LINK}>{t("nightRunBanner.moreInfo")} →</Styled.BannerLink>
        </>
    );

    return (
        <Styled.BannerAlert>
            {showBackgroundImage ? (
                <Styled.BackgroundImageWrapper $isDesktop={isDesktop}>{content}</Styled.BackgroundImageWrapper>
            ) : (
                content
            )}
        </Styled.BannerAlert>
    );
};
